/**
 * Utility functions for authentication
 * These functions retrieve user data dynamically from localStorage
 */

/**
 * Get the login token from localStorage
 * @returns {string|null} The authentication token or null if not logged in
 */
export const getToken = () => {
  try {
    const loginStr = localStorage.getItem('login');
    if (!loginStr) {
      console.warn('No login data found in localStorage');
      return null;
    }
    const login = JSON.parse(loginStr);
    if (!login) {
      console.warn('Login data is null or invalid');
      return null;
    }
    if (!login.token) {
      console.warn('Token not found in login data. Available keys:', Object.keys(login));
      return null;
    }
    return login.token;
  } catch (error) {
    console.error('Error getting token:', error);
    return null;
  }
};

/**
 * Get the user login name (email) from localStorage
 * @returns {string|null} The user email or null if not logged in
 */
export const getUserLoginName = () => {
  try {
    const login = JSON.parse(localStorage.getItem('login'));
    return login && login.loginUser ? login.loginUser : null;
  } catch (error) {
    console.error('Error getting user login name:', error);
    return null;
  }
};

/**
 * Get the user role from localStorage
 * @returns {string|null} The user role or null if not logged in
 */
export const getUserRole = () => {
  try {
    const login = JSON.parse(localStorage.getItem('login'));
    return login && login.role ? login.role : null;
  } catch (error) {
    console.error('Error getting user role:', error);
    return null;
  }
};

/**
 * Get the authentication status from localStorage
 * @returns {boolean} True if user is authenticated, false otherwise
 */
export const isAuthenticated = () => {
  try {
    const login = JSON.parse(localStorage.getItem('login'));
    return login && login.auth === true;
  } catch (error) {
    console.error('Error checking authentication:', error);
    return false;
  }
};

/**
 * Get all login data from localStorage
 * @returns {object|null} The login object containing token, loginUser, role, auth or null
 */
export const getLoginData = () => {
  try {
    return JSON.parse(localStorage.getItem('login'));
  } catch (error) {
    console.error('Error getting login data:', error);
    return null;
  }
};

/**
 * Get authorization header with Bearer token
 * @returns {object} Header object with Authorization Bearer token
 */
export const getAuthHeader = () => {
  const token = getToken();
  return {
    'Content-Type': 'application/json',
    Authorization: `Bearer ${token}`,
  };
};




// WEBPACK FOOTER //
// ./src/utils/auth.js